const addNoBreakSpaces = (string: string) => string.replace(/ /g, String.fromCharCode(160));

export default addNoBreakSpaces;
